import React from 'react'
import { Button, Heading } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import {
  Contract,
  ContractTenant,
  FeatureFlag,
} from '../../../../../common/validations'
import { TenantSelector } from '../../components/TenantSelector/TenantSelector'
import { PerTenantSelectionState } from '../types'

type PerTenantSelectionProps = {
  contract: Contract
  tenants: ContractTenant[]
  selection: PerTenantSelectionState
  featureFlags: FeatureFlag | undefined
  onCancel: () => void
}

export const PerTenantSelection: React.FC<PerTenantSelectionProps> = ({
  contract,
  tenants,
  selection,
  featureFlags,
  onCancel,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const terminationDisallowed = contract.terminationDisallowedReason

  return (
    <>
      <Heading element="h3" size="l" className="phone:font-medium">
        {t('terminateContract:headings.parties')}
      </Heading>

      <TenantSelector
        tenants={tenants}
        contract={contract}
        terminate={selection.terminateTenants}
        handleTerminateChange={(tenantIds) => {
          selection.setTerminateTenants(tenantIds)
          selection.setTenantSelectionConfirmed(false)
        }}
        featureFlags={featureFlags}
      />

      {selection.terminateTenants.length > 0 &&
        !selection.tenantSelectionConfirmed && (
          <div className="mt-8 flex items-center justify-end gap-4">
            <Button type="button" variant="cancel" onClick={onCancel}>
              {t('common:cancel')}
            </Button>
            <Button
              type="button"
              variant="primary"
              disabled={terminationDisallowed !== undefined}
              onClick={() => selection.setTenantSelectionConfirmed(true)}
            >
              {t('common:next')}
            </Button>
          </div>
        )}
    </>
  )
}
